import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import numeral from "numeral";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 16,
    textAlign: "left",
    fontWeight: "800",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    margin: "10px 3px",
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    margin: "1px"
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  row_data: {
    width: '13%',
  },
  row_itemname: {
    width: '16%'
  },
  details: {
    fontWeight: 600,
    fontSize: 10,
    textAlign: "right",
    margin: "2px 10px 2px"
  },
  adj_details:{
    display: 'flex',
    flexDirection: 'row'
  },
  adj_details_header: {
    fontSize: 10
  },
  adj_details_value: {
    fontSize: 10,
    marginLeft: "2px"
  }
  
});

const InvetoryAdjustmentPDF = (props) => {

  const {
    adjno,
    location, 
    adj_type, 
    adjustment_date, 
    items
  } = props.data;

  const header = [
    {title: "Item Name" },
    {title: "Manufacturing Date" },
    {title: "Expiration Date" },
    {title: "Batch No." },
    {title: "Quantity" },
    {title: "Unit" },
    {title: "Price" },
  ];

  return(
    <Document>
      <Page size="A4" style={styles.body}>
        <View style={styles.title}>
          <Text>Inventory Adjustment</Text>
        </View>
        <View style={styles.details}>
          <Text>{`# ${adjno}`}</Text>
        </View>
        <View style={styles.details}>
          <Text>{adjustment_date}</Text>
        </View>

        <View>
          <View style={styles.adj_details}>
            <Text style={[styles.adj_details_header, styles.bold]}>
              Location: 
            </Text>
            <Text style={styles.adj_details_value}>
              {location}
            </Text>
          </View>
          <View style={styles.adj_details}>
            <Text style={[styles.adj_details_header, styles.bold]}>
              Type: 
            </Text>
            <Text style={styles.adj_details_value}>
              {adj_type}
            </Text>
          </View>
        </View> 

        <View style={styles.table}>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            { header.map( row => 
              <Text style={[ styles.rowText, styles.alignCenter, ((["Item Name", "Manufacturing Date"].includes(row.title)) ? styles.row_itemname : styles.row_data) ]}>{row.title}</Text>
            )}
          </View>
          <View>
            {
              items.length !== 0 ?
                items.map( (row, i) => {
                  return (
                    <View key={i} style={styles.row} wrap={false}>
                      <Text style={[styles.row_itemname, styles.rowText, styles.alignLeft]}>{row.item_name}</Text>
                      <Text style={[styles.row_itemname, styles.rowText, styles.alignCenter]}>{row.manufacturing_date}</Text>
                      <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.expiration_date}</Text>
                      <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.batch_no}</Text>
                      <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{numeral(row.qty).format('0,0')}</Text>
                      <Text style={[styles.row_data, styles.rowText, styles.alignCenter]}>{row.uomDesc}</Text>
                      <Text style={[styles.row_data, styles.rowText, styles.alignRight]}>{numeral(row.totalamt).format('00,0.00')}</Text>
                    </View>
                  )
                }
                  
                )
              : ''
            }
          </View>
        </View>


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
}

export default InvetoryAdjustmentPDF;